import register from 'ShopUiBundle/modules/app/registry';
import 'SprykerProductBundle/components/atoms/bike-detail-dynamic-loader';
import './style.scss';

// tslint:disable-next-line
register('bike-detail-color-picker', () => import(/* webpackMode: "lazy" */'./bike-detail-color-picker'));
